import { IContentProvider } from '../types';

export default class LinkProvider implements IContentProvider  {
    pattern = /([^\S]|^)((https?:\/\/(www\.)?)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/\S*)?)/gi;

    isMatched(value: string): boolean {
        const re = new RegExp(this.pattern);
        return re.test(value);
    }

    getContent(resource: string): string {
        return (resource || '').replace(
            this.pattern,
            (match, space, url) => {
                let hyperlink = url.replace(/&nbsp;/gi, ''); // fix for space at the end...
                if (!hyperlink.match('^https?:\/\/')) {
                    hyperlink = 'http://' + hyperlink;
                }

                return space + '<a href="' + hyperlink + '" target="_blank">' + url + ' </a>\n\n';
            }
        );
    }
}
